import { Meta } from '../../../graphql/graphql';
import { Nullable } from 'primereact/ts-helpers';

export default function isHealthServiceProvider(meta?: Nullable<Meta>) {
	if (!meta) {
		return false;
	}

	const value = meta.value?.rawValue || meta.value;
	return value === true || value === 'true';
}
